import React from 'react';
import { AdminProductCategoryList_adminProductCategories } from '@api/graphql/types';
import { compose } from 'react-apollo';
import Select from 'react-select';
import { isArray } from 'util';
import { connect } from 'react-redux';
import { ApplicationState } from 'reducers/';

export interface ProductCategorySelectItem {
    value: string;
    label: string;
}

interface Props {
    name: string;
    value: string | string[];
    placeholder?: string;
    hint?: string;
    isMulti?: boolean;
    onlyWithProducts?: boolean;
    onChangeHandler: (value: any, name: string) => void;
}

interface ReduxProps {
    productCategories: Array<AdminProductCategoryList_adminProductCategories | null>;
}

type PropType = Props & ReduxProps;

class ProductCategorySelect extends React.Component<PropType> {
    private flatten = (list: Array<AdminProductCategoryList_adminProductCategories | null>, nameStub: string = ''): ProductCategorySelectItem[] => {
        if (list) {
            const values = Object.keys(list).map(key => list[key]);
            return values.reduce((a: ProductCategorySelectItem[], b: AdminProductCategoryList_adminProductCategories): ProductCategorySelectItem[] => {
                const label = (nameStub ? `${nameStub} > ${b.name}` : b.name);
                if (b && b.children) {
                    if (this.props.onlyWithProducts && b.product_count === 0) {
                        return a.concat(this.flatten((b.children as AdminProductCategoryList_adminProductCategories[]), label));
                    }
                    return a.concat({value: b.id, label}, this.flatten((b.children as AdminProductCategoryList_adminProductCategories[]), label));
                }
                if (this.props.onlyWithProducts && b.product_count === 0) {
                    return a;
                }
                return a.concat({value: b.id, label});
            }, []);
        }
        return [];
    }

    private selectTheme = (theme: any) => {
        return {
            ...theme,
            borderRadius: '1px',
            colors: {
            ...theme.colors,
            primary25: '#e9ecef',
            primary: '#00A3E0',
            },
        };
    }

    private onSelect = (value: ProductCategorySelectItem | ProductCategorySelectItem[]) => {
        if (!isArray(value)) {
            this.props.onChangeHandler(value.value, this.props.name);
        } else {
            this.props.onChangeHandler((value.map((val) => val.value)), this.props.name);
        }
    }

    public render() {
        const emptyValue: ProductCategorySelectItem = {value: '', label: '---'};
        const options = [emptyValue].concat(this.flatten(this.props.productCategories));
        const selected = options.filter(option => (option.value === this.props.value || (isArray(this.props.value) && this.props.value.includes(option.value))));
        return (
            <>
                <Select isMulti={this.props.isMulti} theme={this.selectTheme} value={selected} onChange={this.onSelect} options={options} />
                {this.props.hint && <span className="form-text m-b-none">{this.props.hint}</span>}
            </>
        );
    }
}

const mapStateToProps = ({productCategories}: ApplicationState) => {
    return { productCategories};
};

export default compose(
    connect(mapStateToProps),
)(ProductCategorySelect);



// WEBPACK FOOTER //
// ./src/components/Form/ProductCategorySelect.tsx